export default __webpack_public_path__ + "static/media/NISHA ANAND.e95f28fe.jpg";